// pages/coachdashboard/Calendar.jsx
import React, { Component } from "react";
import { Button, Card, Collapse, Elevation, Icon } from "@blueprintjs/core";
import AddEventDialog from "../../components-fm/AddEventDialog";
import { BASE_API } from "../../utils/constants";
import { capitalize, getEventEndTime, daysInCurrentMonth, fetchTeamBySlug } from '../../utils/helpers'
import "../../css/Calendar.scss";

/* util uniform – YYYY-MM-DD */
const getDateKey = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
    ).padStart(2, "0")}`;

export default class Calendar extends Component {
    /* ─────────────  INIT  ───────────── */
    constructor(props) {
        super(props);
        const portrait = window.matchMedia("(orientation: portrait)").matches;
        const session = JSON.parse(localStorage.getItem("session")) || {};
        this.teamName = session?.team?.name || "";   // fallback
        this.state = {
            calendarDate: new Date(),        // luna curentă
            calendarDays: [],
            // viewMode:   portrait ? "portrait" : "landscape",
            viewMode: "landscape",
            openDays: new Set(),         // doar pt. portrait
            events: [],                // din API
            /* dialog */
            showAddDialog: false,
            presetDate: null,
            expandedCard: null, // { date, events } sau null
            filter: '',
            org: null,
            teamSlug: null,
            team: null

        };

        this.todayRef = React.createRef();
        this.listRef = React.createRef();
    }

    /* ─────────────  LIFECYCLE  ───────────── */
    async componentDidMount() {
        const search = window.location.search;
        const urlParams = new URLSearchParams(search);
        const org = urlParams.get("org");
        const teamSlug = urlParams.get("echipa");

        if (!teamSlug) {
            console.error("Parametrul ?echipa lipsește din URL");
            return;
        }

        const team = await fetchTeamBySlug(teamSlug);

        this.setState({
            org,
            teamSlug,
            team,
        }, () => {
            this.generateCalendar();
            this.fetchEvents();
        });

        this.mq = window.matchMedia("(orientation: portrait)");
    }

    componentWillUnmount() {
        this.mq?.removeEventListener("change", this.handleOrientationChange);
    }

    componentDidUpdate(_, prev) {
        if (prev.calendarDate.getMonth() !== this.state.calendarDate.getMonth()) {
            this.generateCalendar();
        }
    }


    /* ─────────────  API EVENTS  ───────────── */
    fetchEvents = async () => {
        const teamId = this.state?.team?.id;
        if (!teamId) return;

        // const session = JSON.parse(localStorage.getItem("session"));
        // const teamId = session?.team?.id;
        // if (!teamId) return;

        /* interval = luna curentă ±1 */
        const from = new Date(this.state.calendarDate);
        from.setMonth(from.getMonth() - 1);
        const to = new Date(this.state.calendarDate);
        to.setMonth(to.getMonth() + 1);

        const qs = `team=${teamId}&from=${getDateKey(from)}&to=${getDateKey(to)}`;
        const res = await fetch(`${BASE_API}/api/events?${qs}`);
        const json = await res.json();
        this.setState({ events: json.events || [] });
    };

    /* ─────────────  ORIENTATION  ───────────── */
    handleOrientationChange = (e) => {
        e.matches ? this.scrollToToday() : this.scrollToTop();

        this.setState({
            viewMode: e.matches ? "portrait" : "landscape",
            openDays: new Set(),
        });
    };

    scrollToToday = () =>
        setTimeout(
            () =>
                this.todayRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                }),
            100
        );

    scrollToTop = () =>
        setTimeout(
            () =>
                this.listRef.current?.scrollTo({
                    top: 0,
                    behavior: "smooth",
                }),
            100
        );

    /* ─────────────  CALENDAR  ───────────── */
    generateCalendar = () => {
        const { calendarDate } = this.state;
        const y = calendarDate.getFullYear();
        const m = calendarDate.getMonth();

        const firstWeekday = (new Date(y, m, 1).getDay() + 6) % 7;
        const daysInMonth = new Date(y, m + 1, 0).getDate();
        const daysInPrev = new Date(y, m, 0).getDate();

        const days = [];

        for (let i = firstWeekday; i > 0; i--)
            days.push(new Date(y, m - 1, daysInPrev - i + 1));

        for (let d = 1; d <= daysInMonth; d++) days.push(new Date(y, m, d));

        while (days.length < 35) {
            const next = days.length - (firstWeekday + daysInMonth) + 1;
            days.push(new Date(y, m + 1, next));
        }

        this.setState({ calendarDays: days });
    };

    /* NAV lună */
    prevMonth = () =>
        this.setState(
            (p) => ({
                calendarDate: new Date(
                    p.calendarDate.getFullYear(),
                    p.calendarDate.getMonth() - 1,
                    1
                ),
            }),
            this.fetchEvents
        );

    nextMonth = () =>
        this.setState(
            (p) => ({
                calendarDate: new Date(
                    p.calendarDate.getFullYear(),
                    p.calendarDate.getMonth() + 1,
                    1
                ),
            }),
            this.fetchEvents
        );

    /* VIEW manual */
    setLandscape = () => this.setState({ viewMode: "landscape", openDays: new Set() }, this.scrollToTop);

    setPortrait = () => this.setState({ viewMode: "portrait", openDays: new Set() }, this.scrollToToday);

    /* toggle zi (portrait) */
    toggleDay = (iso) =>
        this.setState((p) => {
            const next = new Set(p.openDays);
            next.has(iso) ? next.delete(iso) : next.add(iso);
            return { openDays: next };
        });

    /* ─────────────  ADD / DELETE EVENT  ───────────── */
    openAddDialog = (dateObj) => this.setState({ showAddDialog: true, presetDate: dateObj, });

    handleDeleteEvent = async (eventId) => {
        if (!window.confirm("Ștergi evenimentul?")) return;

        const res = await fetch(`${BASE_API}/api/events/${eventId}`, {
            method: "DELETE",
        });

        if (res.ok) this.setState((s) => ({
            events: s.events.filter((ev) => ev.event_id !== eventId),
        }));
        else {
            const msg = await res.json();
            alert(msg.error || "Eroare la ștergere");
        }
        this.setState({ expandedCard: null, })
    };

    /* ─────────────  RENDER HELPERS  ───────────── */
    renderEvent = (event) => {
        const { event_type, game_opponent, event_id } = event;

        return (
            <div key={event_id} className="content-row-group">
                <div className={`content-label ${event_type === "game" ? "font-title-game" : event_type === "training" ? "font-title-training" : 'font-title-liber'}`}>
                    {event_type === "game" ? "Joc" : "Antrenament"}
                </div>

                {event_type === "game" && game_opponent && (
                    <div className="content-label-2 game-label">{game_opponent}</div>
                )}
            </div>
        );
    };

    renderXLEvent = (event) => {
        // console.log(event)

        const { event_type, game_opponent, event_id, location, event_time, game_type,
            training_duration, training_type, description, game_opponent_score, game_team_score, game_home_away } = event;
        // console.log(event_type)
        const { org, teamSlug, team } = this.state;
        
        const view = event_type === "training" ? "training-details" : "game-details";
        const editUrl = `/echipa?org=${org}&echipa=${teamSlug}&view=${view}&action=edit&event_id=${event_id}&team_id=${team?.id}`;

        // const editUrl = `/echipa?org=${org}&echipa=${teamSlug}&view=training-details&action=edit&event_id=${event_id}&team_id=${team?.id}`;
        console.log(training_type)

        return (
            <div key={event_id} className="content-row-group">
                <div className="row-0">


                    {event_type === "game" &&
                        <div className={`font-h2 font-title-${event_type}`}>
                            Joc {game_type}
                        </div>
                    }
                    {event_type === "training" &&

                        <div className="font-p-2  flex-align-center">
                            <div className={`font-h2 font-title-${event_type}`}>
                                Antrenament
                            </div>
                            {training_type &&
                                <div className='fm-tag-row'>{training_type.split(",").map((tip, index) => {
                                    if(tip){
                                        return                                     <span key={index} className="fm-tag">{tip.trim()}</span>

                                    }}
                                )}
                                </div>}
                        </div>
                    }
                </div>

                <div className="row-1">
                    {event_type === "game" && game_opponent && (

                        <div className='game-oponents'>
                            <div className={`${game_home_away === "acasa" ? 'order-1' : 'order-3'}`}>
                                <div className="font-p">{this.teamName}</div>
                                {(game_opponent_score !== null && game_team_score !== null) && <div className='team-score'>{game_team_score}</div>}
                            </div>
                            <div className='delimiter-column order-2'> - </div>
                            <div className={`${game_home_away === "acasa" ? 'order-3' : 'order-1'}`}>
                                <div className="font-p">{game_opponent}</div>
                                {(game_opponent_score !== null && game_team_score !== null) && <div className='team-score'>{game_opponent_score}</div>}
                            </div>
                        </div>


                    )}
                </div>
                <div className='row-2'>
                    <div className="col1">

                        <div className="font-p">Locatie: {location}</div>
                        <div className="font-p">Ora: {event_time}  {event_type === "training" && (' - ' + getEventEndTime(event_time, training_duration))}</div>

                        {/* {training_type &&
                            <div className="font-p-2  flex-align-center">Antrenament: <div className='fm-tag-row'>{training_type.split(",").map((tip, index) => (
                                <span key={index} className="fm-tag">{tip.trim()}</span>
                            ))}</div></div>
                        } */}
                        {description &&
                            <div className="font-p-2 ">Note: <span className="font-roboto-light">{description}</span></div>

                        }


                        


                    </div>
                    <div className="col2">
                        <img className="game-icon" src={event_type === "game" ? "/icons/cup.png" : "/icons/training.png"} alt={event_type === "game" ? "Joc" : "Antrenament"} />
                        <div className="font-mont">{event_type === "game" ? "TIME TO WIN" : "TIME TO TRAIN"}</div>
                    </div>
                </div>
                <div className='row-2'>
                    <div className='delete-btn' onClick={() => this.handleDeleteEvent(event_id)}>Sterge 
                        {/* <Icon icon="trash" size='12' className="delete-ev" title="Șterge" /> */}
                    </div>
                        <div className="uecl-button-outline sm-button" onClick={() => {
                            // console.log( `/echipa?org=${org}&echipa={teamSlug}&view=training-details&action=edit&event_id={tr.event_id}&team_id={team_id}`)
                            window.location.href = editUrl
                        }}>
                            Editează
                        </div>
                </div>
            </div>
        );
    };

    renderCards = ({ events, dayOfWeek, dayNum, dateObj, iso }) => (
        <div
            className="sm-card"
            onClick={() => { if (events.length) this.setState({ expandedCard: { dateObj, events, dayOfWeek, dayNum } }) }}
        >
            <div className="day-header">
                <span className="day-nr">{dayNum}</span>
                <span className="day-name">{capitalize(dayOfWeek.slice(0, 3))}</span>
            </div>
            <div className="day-content">
                {events.length
                    ? events.map(this.renderEvent)
                    : <span className="content-label font-title-liber">Liber</span>}
            </div>
            <div className="day-footer">
                <span
                    className="add-text"
                    onClick={(e) => {
                        e.stopPropagation();
                        this.openAddDialog(dateObj);
                    }}
                >
                    Adauga
                </span>
            </div>
        </div>
    );

    renderExpandedCard = () => {
        const { expandedCard } = this.state;
        let monthName = this.state.calendarDate.toLocaleString("default", { month: "long" });

        // console.log(expandedCard)
        if (!expandedCard) return null;

        const { dateObj, events, dayNum, dayOfWeek } = expandedCard;
        let className = 'free-day'
        if (events.length) {
            var event = events.some((e) => e.event_type === "game") && 'game';
            if (event !== 'game') {
                if (events.some((e) => e.event_type === 'training')) {
                    event = 'training'
                }
            }
            // className += game ? " game-day" : " events-day";
            className = ` ${event}-day`
        }
        return (
            <div className="expanded-card-overlay" onClick={() => this.setState({ expandedCard: null })}>
                <div
                    className={`expanded-card ${className}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="ex-card-header">
                        <div className='ex-card-header-title'>{dayNum} {capitalize(monthName)},  {capitalize(dayOfWeek)}</div>
                        <button className="close-btn" onClick={() => this.setState({ expandedCard: null })}>×</button>
                    </div>
                    <div className="ex-card-content">
                        {events.length ? events.map(this.renderXLEvent) : ''}

                    </div>



                </div>
            </div>
        );
    }

    renderXLCards = ({ events, dayOfWeek, dayNum, iso, isOpen, dateObj }) => {
        const { viewMode } = this.state;
        let status = events.length ? 'antrenament' : 'liber'
        status = events.some(event => event.event_type === 'game') ? 'joc' : status;
        let monthName = this.state.calendarDate.toLocaleString("default", { month: "long" });


        // console.log(status)
        return (
            <div className="xl-card">
                <div
                    className="day-header"
                    onClick={() => viewMode === "portrait" && this.toggleDay(iso)}
                >
                    <span className="day-text">
                        <span className="day-nr">{dayNum} {monthName}, </span>
                        <span className="day-name">{capitalize(dayOfWeek)}</span>
                    </span>
                    <div className={`day-status content-label ${status === "joc" ? "font-title-joc" : status == 'antrenament' ? "font-title-antrenament" : 'font-title-liber'}`}>
                        {status}
                    </div>

                    <span
                        className="add-text"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.openAddDialog(dateObj);
                        }}
                    >
                        Adauga
                    </span>
                </div>

                <Collapse isOpen={isOpen}>
                    <div className="day-content">
                        {events.length ? events.map(this.renderXLEvent) : ''}
                    </div>
                </Collapse>
            </div>
        );
    };

    /* ─────────────  RENDER DAY  ───────────── */
    renderDay = (date, dayEvents = []) => {
        const { calendarDate, viewMode, openDays } = this.state;
        const today = new Date();
        const iso = date.toISOString();
        // console.log('iso...', iso)
        const dayNum = date.getDate();
        const dayOfWeek = date.toLocaleDateString("ro-RO", { weekday: "long" });
        const weekend = [0, 6].includes(date.getDay());
        const outside = date.getMonth() !== calendarDate.getMonth();
        const isToday = date.toDateString() === today.toDateString();
        const filter = this.state.filter;

        /* clasă dinamică */
        let className = "calendar-day";
        if (isToday) className += " highlight-today";
        if (weekend) className += " weekend-day";

        if (outside) {
            className += " outside-month";
        } else if (filter === 'vacation') {
            if (dayEvents.length > 0) {
                className += " filtered-out"; // are evenimente => nu e zi liberă
            }
        } else if (filter && !dayEvents.some((e) => e.event_type === filter)) {
            className += " filtered-out";
        }

        if (dayEvents.length) {
            var event = dayEvents.some((e) => e.event_type === "game") && 'game';
            if (event !== 'game') {
                if (dayEvents.some((e) => e.event_type === 'training')) {
                    event = 'training'
                }
            }
            // className += game ? " game-day" : " events-day";
            className += ` ${event}-day`
        }

        const isOpen =
            viewMode === "landscape" ||
            (viewMode === "portrait" && openDays.has(iso));

        const props = {
            events: dayEvents,
            dayOfWeek,
            dayNum,
            iso,
            isOpen,
            dateObj: date
        };

        return (
            <Card key={iso} className={className} elevation={Elevation.ONE}>
                <div ref={isToday ? this.todayRef : null} className="card-wrapper">
                    {viewMode === "portrait"
                        ? this.renderXLCards(props)
                        : this.renderCards(props)}
                </div>
            </Card>
        );
    };

    toggleFilter = (value) => {
        this.setState((prevState) => ({
            filter: prevState.filter === value ? null : value
        }));
    }


    /* ─────────────  RENDER  ───────────── */
    render() {
        // console.log('State......', this.state)
        const { calendarDate, calendarDays, viewMode, events } = this.state;
        const month = calendarDate.toLocaleString("default", { month: "long" });
        const year = calendarDate.getFullYear();
        const selectedMonth = this.state.calendarDate.getMonth(); // 👈 corect

        // console.log({ calendarDate, calendarDays, viewMode, events })
        /* hash date → events[] */
        const eventsByDate = {};
        events.forEach((ev) => {
            const k = getDateKey(new Date(ev.event_date));
            (eventsByDate[k] ||= []).push(ev);
        });

        return (
            <div className={`calendar-layout screen-${viewMode}`} ref={this.listRef}>
                {/* header */}
                <div className="dashboard-header">
                    <div className="calendar-actions">
                        <Button icon="chevron-left" minimal onClick={this.prevMonth} />
                        <h2 style={{ margin: "0 1rem" }}>
                            {capitalize(month)} {year}
                        </h2>
                        <Button icon="chevron-right" minimal onClick={this.nextMonth} />
                    </div>
                    <div className='event-filters'>

                        <div className="font-label-filters ">Filter:</div>
                        <div className="filter-group">
                            <div className="font-label-filters-2 ">
                                {
                                    events
                                        .filter(e =>
                                            e.event_type === "game" &&
                                            new Date(e.event_date).getMonth() === selectedMonth
                                        )
                                        .length
                                }
                            </div>
                            <img
                                className={`game-icon ${this.state.filter === 'game' ? 'active' : ''}`}
                                src="/icons/cup.png"
                                alt="Joc"
                                onClick={() => this.toggleFilter('game')}
                            />
                        </div>
                        <div className="filter-group">
                            <div className="font-label-filters-2 ">
                                {
                                    events
                                        .filter(e =>
                                            e.event_type === "training" &&
                                            new Date(e.event_date).getMonth() === selectedMonth
                                        )
                                        .length
                                }
                            </div>
                            <img
                                className={`training-icon ${this.state.filter === 'training' ? 'active' : ''}`}
                                src="/icons/training.png"
                                alt="Antrenament"
                                onClick={() => this.toggleFilter('training')}
                            />
                        </div>
                        <div className="filter-group">
                            <div className="font-label-filters-2 ">
                                {

                                    daysInCurrentMonth(this.state.calendarDate) -
                                    events.filter(e => new Date(e.event_date).getMonth() === selectedMonth).length
                                }
                            </div>
                            <img
                                className={`day-off-icon ${this.state.filter === 'vacation' ? 'active' : ''}`}
                                src="/icons/vacation1.png"
                                alt="Vacanta"
                                onClick={() => this.toggleFilter('vacation')}
                            />
                        </div>



                    </div>
                    <div className="c-filters">

                        <div className='view-mode'>
                            <div className="font-label-filters">View:</div>
                            <Icon icon="calendar" onClick={this.setLandscape} title="Deschis" />
                            <Icon icon="list" onClick={this.setPortrait} title="Pliabil" />
                        </div>

                    </div>
                </div>

                {/* Grilă zile */}
                <div className="calendar-grid">
                    {calendarDays.map((d) => {
                        const key = getDateKey(d);
                        const list = eventsByDate[key] || [];
                        return (
                            <div key={key} className="calendar-grid-item">
                                {this.renderDay(d, list)}
                            </div>
                        );
                    })}

                    {this.renderExpandedCard()}
                </div>

                {/* Dialog ADD */}
                <AddEventDialog
                    isOpen={this.state.showAddDialog}
                    defaultDate={this.state.presetDate}
                    teamId={JSON.parse(localStorage.getItem("session"))?.team?.id}
                    onClose={(refresh) => {
                        this.setState({ showAddDialog: false });
                        if (refresh) this.fetchEvents();
                    }}
                />
            </div>
        );
    }
}
